/* global http formHelper modal alerts*/
const filterPagination = {
	el: {
		filterCheckbox: document.querySelectorAll('.js-filter'),
		filterContainer: document.querySelector('.calendar__filters'),
		paginationContainer: document.querySelector('.calendar__pagination'),
		cardsContainer: document.querySelector('.calendar__list'),
		navContainer: document.querySelector('.calendar__nav'),
		alertsContainer: document.querySelector('.calendar__alerts'),
		body: document.querySelector('body'),
		spinner: document.querySelector('.spinner-overlay')
	},

	fxRenderCards (items) {
		this.el.cardsContainer.innerHTML = ''

		const pathToProd = window.location.pathname.includes('/campanhas/impostos-simples') ? '/campanhas/impostos-simples' : ''

		const cards = items.map(item => {
			const isChecked = item.smsEnabled === true ? 'checked' : ''
			return `<li class='calendar__list-item'>
				<p class='calendar__list-item-label'>${item.descriptionTypeOfTax}</p>
				<h3 class='calendar__list-item-title js-open-modal' data-modal="calendar" data-modal-container="detail" data-description='${item.description}' data-date='${item.dateCard}'>${item.title}<span>›</span></h3>
				<div class="calendar__list-item-row">
					<div class='calendar__list-item-date'>
						<img class="calendar__list-item-icon" src="${pathToProd}/assets/img/icons/icon-cumprimentoprazos-purple.svg" alt="calendario">${item.dateCard}
					</div>
					<div class='calendar__pill-field'>
						<input class='calendar__pill-checkbox js-alert js-checkbox' type='checkbox' name='${item.id}' value='${item.smsEnabled}' id='alertSMS-${item.id}' data-modal='calendar' data-modal-container='alert' ${isChecked} data-type='${item.descriptionTypeOfTax}'>
						<label class="calendar__pill-label" for="alertSMS-${item.id}">SMS ativo</label>
					</div>
				</div>
			</li>`
		}).join('')

		this.el.cardsContainer.innerHTML += cards

		$(this.el.cardsContainer).fadeIn()

		//add loader
		$(this.el.spinner).css('display', 'none')
		this.el.body.classList.remove('no-scroll-hidden')

		//-activate modal
		const btnOpenModal = this.el.cardsContainer.querySelectorAll('.js-open-modal'),
			btnCloseModal = document.querySelectorAll('.js-close-modal')
		for(const btn of btnOpenModal) {
			btn.addEventListener('click', e => modal.fxOpenModal(e, e.currentTarget))
		}

		for(const btn of btnCloseModal) {
			const mod = btn.closest('.modal')
			mod.dataset.modal === 'calendar' && btn.addEventListener('click', e => modal.fxCloseModal(e.currentTarget))
		}
	},

	//next/prev buttons
	fxRenderNavBtns (container, currentPage, totalPages) {
		container.innerHTML = ''

		let nextPageNumber = '',
			prevPageNumber = '',
			prevClass = '',
			nextClass = ''

		if(currentPage === 1) {
			nextPageNumber = `data-page='${currentPage + 1}'`
			prevPageNumber = ''
			nextClass = 'js-nav-page'
			prevClass = 'is-active'
		} else if(currentPage === totalPages) {
			nextPageNumber = '',
			prevPageNumber = `data-page='${currentPage - 1}'`
			nextClass = 'is-active'
			prevClass = 'js-nav-page'
		} else {
			nextPageNumber = `data-page='${currentPage + 1}'`,
			prevPageNumber = `data-page='${currentPage - 1}'`
			nextClass = 'js-nav-page'
			prevClass = 'js-nav-page'
		}

		const navContent = `
			<div class='calendar__nav-btn calendar__nav-btn--prev ${prevClass}' ${prevPageNumber}>›</div>
			<p class='calendar__nav-text'>Próximos eventos</p>
			<div class='calendar__nav-btn calendar__nav-btn--next ${nextClass}' ${nextPageNumber}>›</div>
		`
		container.innerHTML += navContent
	},

	//bullets
	fxRenderPagination(containerPagination, currentPage, totalPages) {
		containerPagination.innerHTML = ''
		
		//bullets
		for(let i = 1; i < totalPages + 1; i++) {
			const isActive = i === currentPage ? 'is-active' : 'js-nav-page',
				dataPage = i !== currentPage ? `data-page='${i}'` : '',
				pageItem = `<li class='calendar__pagination-bullet ${isActive}' ${dataPage}></li>`

			containerPagination.innerHTML += pageItem
		}

		const filterCurrentPage = containerPagination.closest('.calendar').querySelector('.calendar__filters')
		filterCurrentPage.dataset.currentPage = currentPage
	},

	fxRenderPaginationAndNavigation(containerPag, containerNav, currentPage, totalPages) {
		this.fxRenderPagination(containerPag, currentPage, totalPages)
		this.fxRenderNavBtns (containerNav, currentPage, totalPages)

		const goToPageItems = containerPag.closest('.calendar').querySelectorAll('.js-nav-page')
		this.fxTriggerPagination(goToPageItems)
	},

	fxTriggerPagination (arrayButtons) {
		for(const btn of arrayButtons) {
			btn.addEventListener('click', e => {
				const item = e.currentTarget

				if(!item.classList.contains('is-active')) {
					this.fxSendData(this.el.filterContainer, this.el.filterCheckbox, item.dataset.page, true)
				}
			})
		}
	},

	fxSetAlertAllCounter (el, data) {
		data.forEach(item => {
			if(item.name === el.dataset.type) {
				el.dataset.counter = item.counterSelectedAlert

				el.dataset.counter === el.dataset.alerts && alerts.fxToggleBtn(el, true)
			}
		})
	},

	fxSendData(element, filters, page = 1, scrollTop = false) {
		const formData = {},
			endpoint = element.dataset.endpoint

		formData['filterType'] = []
		
		filters.forEach(el => {
			const item = {
				'name': el.name,
				'counter': Number(el.dataset.totalItems),
				'isChecked': el.checked
			}
			formData['filterType'].push(item)
		})

		formData['currentPage'] = Number(page)

		//add loader
		if(scrollTop === true) {
			$(this.el.spinner).css('display', 'flex')
			this.el.body.classList.add('no-scroll-hidden')
		}
		
		//remove content from cards container
		$(this.el.cardsContainer).fadeOut()

		$.ajax({
			url: endpoint,
			type: 'POST',
			data: formData,
			contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
			dataType: 'json'
		}).done((data, textStatus, jqXHR) => {
			if(jqXHR.status === 200) {
				//remove loader
				this.fxRenderPaginationAndNavigation(this.el.paginationContainer, this.el.navContainer, data.currentPage, data.totalPages)
				this.fxRenderCards(data.calendarViewModel)
				
				//scroll to top of cards list
				if(scrollTop === true) {
					$('html, body').animate({
						scrollTop: $(element).offset().top - ($('.header.js-sticky').height() * 2.2)
					}, 200)
				}

				//-activate alert checkbox
				const calendarContainer = this.el.cardsContainer.closest('.calendar'),
					alertCheckboxes = calendarContainer.querySelectorAll('.js-alert'),
					alertAllCheckboxes = calendarContainer.querySelectorAll('.js-alert-all')
				
				for(const checkbox of alertCheckboxes) {
					formHelper.fxToggleCheckbox(checkbox)
					checkbox.addEventListener('change', e => {
						alerts.fxToggleAlert(e)
					})
				}

				for(const checkbox of alertAllCheckboxes) {
					this.fxSetAlertAllCounter(checkbox, data.typeTax)
				}
			}
		}).fail((data, textStatus, jqXHR) => {
			console.log(data, textStatus, jqXHR)
		})
	},

	fxToggleDisabledAlertsAll (element) {
		const alertAllBtns = document.querySelectorAll('.js-alert-all')

		for(const btn of alertAllBtns) {
			if(btn.dataset.type === element.name) {
				element.checked ? btn.removeAttribute('disabled') : btn.disabled = true
			}
		}
	},

	events() {
		//change of filters
		for (const filter of this.el.filterCheckbox) {
			filter.addEventListener('change', e => {
				this.fxSendData(this.el.filterContainer, this.el.filterCheckbox, 1, true)
				this.fxToggleDisabledAlertsAll(e.currentTarget)
			})
		}
		//first call
		this.fxSendData(this.el.filterContainer, this.el.filterCheckbox, 1)

		//toggle alertAllBtns
		const btnAlertAll = this.el.alertsContainer.querySelectorAll('.js-alert-all')
		for (const btn of btnAlertAll) {
			formHelper.fxToggleCheckbox(btn)
			btn.addEventListener('change', e => {
				alerts.fxToggleAlert(e)
			})
		}
	},

	init() {
		if(this.el.filterCheckbox.length === 0) return
		this.events()
	}
}

filterPagination.init()